/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./gaugeModern.vue?vue&type=template&id=3b334552&scoped=true"
import script from "./gaugeModern.vue?vue&type=script&lang=js"
export * from "./gaugeModern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b334552",
  null
  
)

export default component.exports